import { defineMessages } from 'react-intl';

import globalMessages from '../../utils/globalMessages';

const messages = defineMessages({
    ...globalMessages,

    title: {
        id: 'collections.title',
        defaultMessage: 'Recebível',
    },

    titleCollection: {
        id: 'collections.titleCollection',
        defaultMessage: 'Recebível {entity}',
    },

    btnNewInvoice: {
        id: 'collections.btnNewInvoice',
        defaultMessage: 'Nova Nota Fiscal',
    },

    registrationInfo: {
        id: 'collections.registrationInfo',
        defaultMessage: 'Informações Recebível',
    },

    deleteCollection: {
        id: 'collections.deleteCollection',
        defaultMessage: 'Excluir Recebível',
    },

    name: {
        id: 'global.name',
        defaultMessage: 'Nome',
    },

    cnpj: {
        id: 'global.cnpj',
        defaultMessage: 'CPF/CNPJ',
    },

    email: {
        id: 'global.email',
        defaultMessage: 'E-mail',
    },

    city: {
        id: 'global.city',
        defaultMessage: 'Cidade',
    },

    state: {
        id: 'global.state',
        defaultMessage: 'Estado',
    },

    home: {
        id: 'home.title',
        defaultMessage: 'Início',
    },
});

export default messages;
